import {Debugger} from "debug";
import {AgendaelementId, DokumentId, ImporterMicrosoftOneDriveDokumentISakSpesifikasjon, SaksdokumentModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {Injectable} from "@angular/core";
import {OneDriveFil} from "./OneDriveFilvelgerGui";
import {DokumentOgEksisterende, SkyfilOpplasting} from "web-ng2/delt/komponenter/filvelger-skytjenester/SkyfilOpplasting";
import {SaksdokumentDatatjeneste} from "felles-ng2/tjenester/datalager/SaksdokumentDatatjeneste";

const debug: Debugger = require('debug')('OneDriveOpplasting');

/**
 * Tjeneste for opplasting av dokumenter fra google drive til styreplan.
 * Merk at vi i motsetning til i {@link SakWebRessurs} ikke tar oss bryderiet med å vise dokumenter i GUI med progresjonsindikator mens disse lastes opp.
 *
 * For fremdrift kan kaller av registrerGoogleDokumenter() lytte til notify callback i promiset.
 */
@Injectable()
export class OneDriveOpplasting extends SkyfilOpplasting<ImporterMicrosoftOneDriveDokumentISakSpesifikasjon, OneDriveFil> {

    constructor(private avhengigheter: OneDriveOpplastingAvhengigheter) {
        super(debug);
    }

    // SkyfilOpplasting implementasjon

    protected somSpesifikasjon(fil: DokumentOgEksisterende<OneDriveFil>, aksessToken: string): ImporterMicrosoftOneDriveDokumentISakSpesifikasjon {
        return {
            filId: fil.fil.fileId,
            driveId: fil.fil.driveId,
            sharePointEndpoint: fil.fil.sharePointEndpoint,
            navn: fil.fil.filnavn,
            url: fil.fil.url,
            oauthToken: aksessToken
        };
    }

    protected registrerNyttDokument(sakId: AgendaelementId, spesifikasjon: ImporterMicrosoftOneDriveDokumentISakSpesifikasjon): Promise<SaksdokumentModell> {
        return this.avhengigheter.registrerNyttDokument(sakId, spesifikasjon);
    }

    protected registrerNyDokumentVersjon(sakId: AgendaelementId, dokumentId: DokumentId, spesifikasjon: ImporterMicrosoftOneDriveDokumentISakSpesifikasjon): Promise<SaksdokumentModell> {
        return this.avhengigheter.registrerNyDokumentVersjon(sakId, dokumentId, spesifikasjon);
    }
}


@Injectable()
export class OneDriveOpplastingAvhengigheter {

    constructor(private saksdokumentDatatjeneste:SaksdokumentDatatjeneste) {
    }

    registrerNyttDokument(id: AgendaelementId, spesifikasjon: ImporterMicrosoftOneDriveDokumentISakSpesifikasjon): Promise<SaksdokumentModell> {
        return this.saksdokumentDatatjeneste.registrerMicrosoftOneDriveDokumentISak(id, spesifikasjon);
    }

    registrerNyDokumentVersjon(id: AgendaelementId, dokumentId: DokumentId, spesifikasjon: ImporterMicrosoftOneDriveDokumentISakSpesifikasjon): Promise<SaksdokumentModell> {
        return this.saksdokumentDatatjeneste.registrerMicrosoftOneDriveSomDokumentversjon(id, dokumentId, spesifikasjon);
    }
}
